export default __webpack_public_path__ + "static/media/wdxbl.c4eed068.png";